import { defineMessages } from 'react-intl';

const signinMessages = defineMessages({
  header: {
    id: 'signin.header',
    defaultMessage: 'Choose a sign in method',
    description: 'Main heading for sign in page.',
  },
  changeSigninOption: {
    id: 'signin.changeSigninOption',
    defaultMessage: 'Sign in with a different option',
    description: 'Action to see all available sign in options.',
  },
  organizationSigninButton: {
    id: 'signin.organizationSigninButton',
    defaultMessage: 'Organization SSO',
    description: 'Action to select to sign in through an organization.',
  },
  organizationSigninInfo: {
    id: 'signin.organizationSigninInfo',
    defaultMessage:
      'For enterprise single sign-on (SSO), please visit your company’s direct URL.',
    description:
      'Information to customers wanting to sign in through an organization.',
  },
  signInMechanismSeparator: {
    id: 'signin.signInMechanismSeparator',
    defaultMessage: 'or',
    description:
      'Visually separates sign in mechanisms from each other vertically, adding "or" In between.',
  },
  signinButton: {
    id: 'signin.signinButton',
    defaultMessage: 'Sign in',
    description: 'Signin button label for Singin page',
  },
  createOrSignInButton: {
    id: 'signin.createOrSignInButton',
    defaultMessage: 'Create or Sign in',
    description: 'Create or Signin Button for the Signin page',
  },
  essoSignInDescription: {
    id: 'signin.esso',
    defaultMessage:
      'Use your organization email (available for select companies)',
    description: 'ESSO signin description',
  },
  signInMechanismSeparatoLowerCase: {
    id: 'signin.signInMechanismSeparator',
    defaultMessage: 'or',
    description:
      'Visually separates sign in mechanisms from each other vertically, adding "or" In between.',
  },
  essoInputPlaceHolder: {
    id: 'signin.essoInputPlaceholder',
    defaultMessage: 'Your organization email',
    description: 'Placeholder text ESSO email Input',
  },
  builderIdRecommendation: {
    id: 'signin.builderIdRecommendation',
    defaultMessage: 'Recommended for individuals',
    description: 'Recommended badge for builder ID',
  },
  apnBadgeRecommendation: {
    id: 'signin.apnBadgeRecommendation.text',
    defaultMessage: 'For AWS Partners',
    description: 'APN badge',
  },
  preferredIdpNotFound: {
    id: 'signin.preferredIdpNotFound',
    defaultMessage:
      'The selected sign in method was not found. Choose a different sign in method to continue.',
    description:
      'Warning message when the selected sign in method was not found',
  },
  preferredIdpError: {
    id: 'signin.preferredIdpError',
    defaultMessage:
      'Oh no, something went wrong. Please refresh the page, or choose a different sign in method to continue.',
    description:
      'Error message when configuration could not be retrieved for the selected sign in method',
  },
  apnDeprecationBannerContent: {
    id: 'signin.apnDeprecationBannerContent',
    defaultMessage:
      'If you previously used the AWS Partner Network sign-in, use the same email to sign in with AWS Builder ID. Your AWS Training and Certification history and data with AWS Partner Network will be available under AWS Builder ID.',
    description: 'The main content of the APN deprecation banner',
  },
  apnDeprecationBannerDismissLabel: {
    id: 'signin.apnDeprecationBannerDismissLabel',
    defaultMessage: 'Dismiss message',
    description: 'The aria-label for the banner message dismiss button',
  },
});

export default signinMessages;
